import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken, removeToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: '/api',
  timeout: 300000 // 请求超时时间设置为5分钟，适应文件上传需求
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 首先尝试获取管理员token
    let token = getToken('admin')
    
    // 如果没有管理员token，检查是否为学生相关请求，尝试获取学生token
    if (!token && (config.url.includes('/user/') || config.url.includes('/student/'))) {
      token = getToken('student')
    }
    
    // 如果还没有token，则尝试获取用户token
    if (!token) {
      token = getToken('user')
    }
    
    // 根据请求URL判断token类型（仅用于日志记录）
    let tokenSource = 'none'
    if (getToken('admin')) tokenSource = 'admin'
    else if (getToken('student')) tokenSource = 'student'
    else if (getToken('user')) tokenSource = 'user'
    
    if (token) {
      // 直接使用原始token，不添加Bearer前缀
      config.headers['Authorization'] = token
      // console.log('请求添加token:', config.headers['Authorization'])
    }
    
    // 检查是否为FormData类型的请求
    const isFormData = config.data instanceof FormData
    
    // 如果是FormData类型的请求，不要手动设置Content-Type，让浏览器自动设置
    if (isFormData) {
      console.log('检测到FormData请求，将使用自动设置的Content-Type')
      // 确保不会覆盖自动设置的Content-Type
      delete config.headers['Content-Type']
      
      // 检查请求URL是否为修改密码接口
      if (config.url.includes('/manage/info_update_password')) {
        // 将FormData转换为URLSearchParams，以支持application/x-www-form-urlencoded格式
        const params = new URLSearchParams()
        for (const [key, value] of config.data.entries()) {
          params.append(key, value)
        }
        config.data = params
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        console.log('密码修改请求，已转换为application/x-www-form-urlencoded格式')
      }
    }
    
    return config
  },
  // error => {
  //   console.log(error)
  //   return Promise.reject(error)
  // }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 这里可以根据实际情况对返回的数据进行处理
    if (res.code === 200 || res.code === 0) {
      return res
    } else {
      // 处理非200状态码的情况
      // 因为此处后端返回状态码一直为200，所以直接返回数据
      return res
    
    }
    // else {
    //   ElMessage({
    //     message: res.message || '请求失败',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   return Promise.reject(new Error(res.message || '请求失败'))
    // }
  },
  error => {
    console.log('err', error)
    
    // 检查是否为403状态码：教师端额外判断登录是否超过2小时
    if (error.response && error.response.status === 401) {
      try {
        const isTeacherPage = window.location.href.includes('/teacher')
        const loginTimeStr = localStorage.getItem('loginTime')
        let isTeacherUser = false
        const loginDataStr = localStorage.getItem('loginData')
        if (loginDataStr) {
          try {
            const parsed = JSON.parse(loginDataStr)
            isTeacherUser = parsed?.userType === 'teacher'
          } catch (e) {
            console.warn('解析 loginData 失败：', e)
          }
        }

        // 仅在教师端或教师用户时进行2小时的超时判断
        if ((isTeacherPage || isTeacherUser) && loginTimeStr) {
          const loginTs = new Date(loginTimeStr).getTime()
          const now = Date.now()
          const twoHoursMs = 2 * 60 * 60 * 1000
          const isTimeout = now - loginTs > twoHoursMs
          if (isTimeout) {
            // 提示并触发本地退出清理与标题栏清空
            if (!isHandlingTokenExpired) {
              isHandlingTokenExpired = true
              try {
                const hash = typeof window !== 'undefined' ? (window.location.hash || '') : ''
                const path = hash.replace(/^#/, '')
                const pathname = typeof window !== 'undefined' ? (window.location.pathname || '') : ''
                const currentPath = path || pathname || ''
                const isHomePage = currentPath === '/'
                const isLoginPage = currentPath.startsWith('/admin/login') || currentPath.startsWith('/teacher/login') || currentPath.startsWith('/student/login')
                if (!(isHomePage || isLoginPage)) {
                  ElMessage({ message: '登录超时，请重新登录', type: 'warning', duration: 2500 })
                }
              } catch (e) {
                console.warn('ElMessage 提示失败：', e)
              }
              // 通知组件（如教师标题栏）进行本地数据清理
              if (typeof window !== 'undefined') {
                try {
                  const hash = typeof window !== 'undefined' ? (window.location.hash || '') : ''
                  const path = hash.replace(/^#/, '')
                  const pathname = typeof window !== 'undefined' ? (window.location.pathname || '') : ''
                  const currentPath = path || pathname || ''
                  const isHomePage = currentPath === '/'
                  const isLoginPage = currentPath.startsWith('/admin/login') || currentPath.startsWith('/teacher/login') || currentPath.startsWith('/student/login')
                  if (!(isHomePage || isLoginPage)) {
                    window.dispatchEvent(new CustomEvent('userTimeout', { detail: { message: '登录已超时，请重新登录' } }))
                  }
                } catch (e) {
                  console.warn('触发 userTimeout 事件失败：', e)
                }
              }
              // 清除token与本地存储
              removeToken('user')
              removeToken('teacher')
              localStorage.removeItem('userInfo')
              localStorage.removeItem('loginData')
              localStorage.removeItem('loginTime')
              // 跳转到教师登录页
              setTimeout(() => {
                try {
                  const hash = typeof window !== 'undefined' ? (window.location.hash || '') : ''
                  const path = hash.replace(/^#/, '')
                  const pathname = typeof window !== 'undefined' ? (window.location.pathname || '') : ''
                  const currentPath = path || pathname || ''
                  const isHomePage = currentPath === '/'
                  const isLoginPage = currentPath.startsWith('/admin/login') || currentPath.startsWith('/teacher/login') || currentPath.startsWith('/student/login')
                  if (!(isHomePage || isLoginPage)) {
                    window.location.href = `/teacher/login?reason=timeout&_t=${Date.now()}`
                  }
                } finally {
                  isHandlingTokenExpired = false
                }
              }, 1000)
            }
            return Promise.reject(error)
          }
        }
      } catch (e) {
        console.warn('处理教师端401与超时逻辑失败：', e)
      }
      // 默认处理（非教师或未超过两小时）
      handleTokenExpired()
      return Promise.reject(error)
    }
    
    // 检查是否为401未授权错误
    if (error.response && error.response.status === 401) {
      handleTokenExpired()
      return Promise.reject(error)
    }
    
    // 处理500错误
    if (error.response && error.response.status === 500) {
      return {
        code: 200,
        data: []  // 返回空数组作为默认数据
      }
    }
    
    // ElMessage({
    //   message: error.message || '请求失败',
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

// 防止重复处理token过期的标志
let isHandlingTokenExpired = false

// 处理token过期的函数
function handleTokenExpired() {
  // 如果正在处理token过期，直接返回
  if (isHandlingTokenExpired) {
    return
  }
  
  // 设置标志，防止重复处理
  isHandlingTokenExpired = true
  
  // 判断当前是否在管理员页面
  const isAdminPage = window.location.href.includes('/admin')
  const hash = typeof window !== 'undefined' ? (window.location.hash || '') : ''
  const path = hash.replace(/^#/, '')
  const pathname = typeof window !== 'undefined' ? (window.location.pathname || '') : ''
  const currentPath = path || pathname || ''
  const isHomePage = currentPath === '/'
  const isLoginPage = currentPath.startsWith('/admin/login') || currentPath.startsWith('/teacher/login') || currentPath.startsWith('/student/login')
  const tokenType = isAdminPage ? 'admin' : 'user'
  
  // 清除token
  removeToken(tokenType)
  
  // 清除用户信息
  localStorage.removeItem('userInfo')
  localStorage.removeItem('loginData')
  
  // 在首页或任意登录页静默处理：不提示、不跳转
  if (isHomePage || isLoginPage) {
    isHandlingTokenExpired = false
    return
  }
  
  // 只在非登录页的管理员页面显示提示信息
  if (isAdminPage) {
    ElMessage({ message: '登录已过期，请重新登录', type: 'warning', duration: 3000 })
  }
  
  // 延迟跳转，确保消息能够显示
  setTimeout(() => {
    // 根据页面类型进行不同的跳转处理
    if (isAdminPage) {
      // 管理员页面跳转到登录页面
      window.location.href = `/admin/login?reason=expired&_t=${Date.now()}`
    }
    isHandlingTokenExpired = false
  }, 2000)
}

export default service
